(function ($) {
    "use strict";

    const assetId = '~/theme/v1/Views/Document/ViewDocumentTemplatedNewsletters.min.js';

    if (!window.umwAssets?.[assetId]) {
        console.error(`No context found for ${assetId}`);
        return;
    }

    for (const ctx of window.umwAssets[assetId]) {
        const newsletterControl = document.querySelector('.subscribe-newsletter');
        const newsletterDoc = document.querySelector('#' + ctx.mainPanelId);
        const newsletterDocDescription = newsletterDoc.querySelector('.description');
        if (newsletterControl) {
            newsletterDoc.classList.add('has-newsletter-control');
            newsletterDocDescription.appendChild(newsletterControl);            
            newsletterControl.querySelector('header').classList.add('d-none');         
        }
    }
}(jQuery));